import React from 'react'
import { Video } from '@shared/components/video'
import cn from 'classnames'

import styles from './styles.module.scss'

interface VideoGridProps {
	videos: { url: string; poster: string }[]
}

export const VideoGrid: React.FC<VideoGridProps> = ({ videos }) => {
	return (
		<div className={cn(styles.section, styles.videosSection)}>
			{videos.map((video) => (
				<div key={video.url} className={styles.videoWrapper}>
					<Video src={video.url} poster={video.poster} className={styles.video} />
				</div>
			))}
		</div>
	)
}
